/* Countries offered on client / prospect records, with the currency we'd
   normally quote them in. EQUIPR only quotes AUD, GBP or USD today, so
   anything outside Australia and the sterling zone suggests USD. */
const GBP = ["United Kingdom", "Guernsey", "Isle of Man", "Jersey"];

export const COUNTRIES = [
  "Australia", "New Zealand", "United Kingdom", "Ireland", "United States", "Canada",
  "Argentina", "Austria", "Bahrain", "Bangladesh", "Belgium", "Botswana", "Brazil", "Brunei",
  "Bulgaria", "Chile", "China", "Colombia", "Croatia", "Cyprus", "Czechia", "Denmark",
  "Ecuador", "Egypt", "Estonia", "Fiji", "Finland", "France", "Germany", "Ghana", "Greece",
  "Guernsey", "Hong Kong SAR", "Hungary", "Iceland", "India", "Indonesia", "Isle of Man",
  "Israel", "Italy", "Japan", "Jersey", "Jordan", "Kenya", "Kuwait", "Latvia", "Lithuania",
  "Luxembourg", "Malaysia", "Malta", "Mexico", "Mongolia", "Morocco", "Mozambique",
  "Namibia", "Netherlands", "Nigeria", "Norway", "Oman", "Papua New Guinea", "Peru",
  "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Saudi Arabia", "Singapore",
  "Slovakia", "Slovenia", "Solomon Islands", "South Africa", "South Korea", "Spain",
  "Sri Lanka", "Sweden", "Switzerland", "Taiwan", "Tanzania", "Thailand", "Türkiye",
  "United Arab Emirates", "Vanuatu", "Vietnam", "Zambia", "Zimbabwe",
];

export const suggestedCurrency = (country) => {
  const c = (country || "").trim();
  if (!c || c === "Australia") return "AUD";
  if (GBP.includes(c)) return "GBP";
  return "USD";
};
